import calendar from '@iconify/icons-carbon/calendar';
import phoneVoice from '@iconify/icons-carbon/phone-voice';
import { Box, Button, Container, Grid, Typography } from '@mui/material';
import { Iconify } from '@larvitu/shared/mui/ui-iconify';
import { Link } from '@larvitu/shared/next/mui';
import { SectionStyle } from './SectionStyle';
import besprechung from "../../public/assets/images/geiges/859_Dr_Geiges_030.jpg";

import Image, { type StaticImageData } from 'next/image';
import type { Theme } from '@mui/material/styles';
import type { FC } from 'react';

// -----------------------------------------------------------------------------
// *****************************************************************************
// -----------------------------------------------------------------------------

interface QuickHelpComponentProps {
  title: string;
  content?: string;
  image?: StaticImageData;
  containedButton: string;
  containedLink: string;
  phone?: string;
  callButton: string | boolean;
}

export const QuickHelpComponent: FC<QuickHelpComponentProps> = ({
  title,
  content = '',
  image = besprechung,
  containedButton,
  containedLink,
  phone,
  callButton,
}) => {
  const containedButtonHover = {
    backgroundColor: 'rgba(24, 84, 77, 0.1)',
    border: '1px solid #174741',
    color: 'rgba(24, 84, 77, 1)',
  };

  return (
    <Box bgcolor={(theme: Theme) => theme.palette.secondary.lighter}>
      <Grid
        container
        direction={{ xs: 'column', md: 'row' }}
        alignItems="stretch"
      >
        <Grid item xs={12} md={6} width="100%">
          <Box
            position="relative"
            minHeight={{ md: 450 }}
            height={{ xs: 350, sm: 450, md: '100%' }}
          >
            <Image
              src={image}
              sizes="(max-width: 900px) 100vw, (max-width: 1536px) 50vw, 45vw"
              // layout="fill"
              fill
              alt="besprechung"
              title="besprechung"
              style={{
                objectFit: 'cover',
                objectPosition: '50% 30%',
              }}
              placeholder="blur"
            />
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <SectionStyle sx={{ height: '100%' }}>
            <Container
              maxWidth="md"
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <Typography mb={4} gutterBottom component="h2" variant="h3">
                {title}
              </Typography>
              {content
                ? (
                  <Typography mb={4} paragraph gutterBottom>
                    {content}
                  </Typography>
                )
                : null}
              <Grid
                container
                spacing={2}
                direction={{ xs: 'column', sm: 'row' }}
              >
                <Grid item xs={12} sm={3}>
                  <Link href={containedLink}>
                    <Button
                      size="large"
                      sx={{ minWidth: 240, '&:hover': containedButtonHover }}
                      variant="contained"
                      endIcon={containedLink === '/contact' ? <Iconify icon={calendar} /> : null}
                    >
                      {containedButton}
                    </Button>
                  </Link>
                </Grid>

                {callButton === false ? null : (
                  <Grid
                    item
                    display={{ xs: 'block', md: 'none' }}
                    xs={12}
                    sm={3}
                  >
                    <Link href={`tel:${phone ?? ''}`}>
                      <Button
                        size="large"
                        sx={{ minWidth: 240 }}
                        variant="outlined"
                        endIcon={<Iconify icon={phoneVoice} />}
                      >
                        {callButton}
                      </Button>
                    </Link>
                  </Grid>
                )}
              </Grid>
            </Container>
          </SectionStyle>
        </Grid>
      </Grid>
    </Box>
  );
};
